// The currency lib — the single import path for all currency formatting.
//
//   import { useFormattedCurrency, useQuickAmounts } from '@/lib/currency';
//
// All currency formatting (the only currency `Intl.NumberFormat`, the per-currency
// quick-amount tiers, the range/slider adapter) lives under `src/lib/currency/`.
// Components hold zero currency logic — no Intl, no `* exchangeRate`, no `$`/token
// literal, no tier arrays. Enforced by FQ-160.
//
// Edge / server surfaces import `@/lib/currency/server` directly (it is the only
// edge-safe module and must not pull in the client hook).

// Currency data lives in config (edge-safe, used by middleware + store); re-export
// here so the lib is the single import path for currency concerns.
export {
  COUNTRY_CURRENCY_MAP,
  CURRENCY_LIST,
  type CurrencyInfo,
  getCurrencyByCode,
} from '@/config/currencies';
export {
  currencyParts,
  type FormatMode,
  type FormatOptions,
  formatBalance,
  formatD6,
  formatD6Signed,
  formatD9,
  formatMarketCapAxis,
  formatPrice,
  formatPriceFixed,
  formatQuickAmount,
} from './format';
export {
  niceSnap,
  QUICK_AMOUNTS_BY_CURRENCY,
  quickAmountTiers,
  resolveLocalAmount,
  selectQuickAmounts,
  USD_ANCHORS,
} from './quick-amounts';
export {
  EPSILON,
  formatRangeEndpoint,
  formatRangeValueLabel,
  MILLION,
  type RangeFormat,
  type RangeFormatSpec,
  THOUSAND,
} from './range';
export { useFormattedCurrency } from './use-formatted-currency';
export {
  type QuickAmount,
  useQuickAmounts,
} from './use-quick-amounts';
